<section class="page-control">
  <div class="flex justify-content-between w-full align-items-center">
    <h2>Partneri</h2>
    <button class="main-btn" [routerLink]="['./add']">
      Dodaj <i class="pi pi-plus"></i>
    </button>
  </div>
</section>

<section class="page-control">
  <div class="grid w-full">
    <!-- FILTER FIELDS  -->
    <div class="col-12 sm:col-8">
      <form [formGroup]="form" class="grid">
        <div class="col-6">
          <label class="mb-2 block">Ime kompanije</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="company"
          />
        </div>

        <div class="col-6">
          <label class="mb-2 block">Kontakt osoba</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="contact"
          />
        </div>
      </form>
    </div>

    <!-- FILTER BUTTONS -->
    <div class="col-12 sm:col-4">
      <div class="flex justify-content-end mt-4">
        <button class="main-btn" (click)="onResetFilter()">
          Osveži <i class="pi pi-refresh"></i>
        </button>
      </div>
    </div>
  </div>
</section>

<app-table
  [tableHeader]="fieldsService.tableHeader"
  [tableData]="partners.data"
  [loading]="loading"
  (handleDelete)="onDelete($event)"
  (handlePageChange)="onPageChange($event)"
  [paginator]="partners.pagination"
  [options]="{
    showEdit: true,
    showDelete: true
  }"
>
</app-table>
